import React, { useRef, useState, useEffect } from "react";
import { setLoader } from "../../redux/actions";
import {
  Row,
  Button,
  CustomInput,
} from "reactstrap";
import { Colxx } from "../common/CustomBootstrap";
import FormCustom from "./FormCustom";
import { connect } from "react-redux";
import DataTable from "./DataTable";
import _axios from "../../libs/axios";
import { NotificationManager } from "../common/react-notifications";
import { objToQueryString } from "../../helpers/Utils"
import { cloneDeep } from "lodash"

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const Side = props => {

  const [search, setSearch] = useState('')
  const [formFilter, setFormFilter] = useState(null)
  const [progressBar, setProgressBar] = useState(false)
  const [data, setData] = useState([])
  const [rowCount, setRowCount] = useState(0)
  const [columns, setColumns] = useState([])

  const prevStateFormFilter = usePrevious(formFilter);
  const prevStateSearch = usePrevious(search);

  const { config, side, addItems, removeItems } = props

  // const prevPropsAddItems = usePrevious(addItems);
  // const prevPropsRemoveItems = usePrevious(removeItems);

  const checkedItem = (id, val) => {
    console.log(val)
    let temp = cloneDeep(data)
    temp.map(e => e.isChecked = e.ID === id ? val : e.isChecked )
    setData(temp)
    const selected = {
      formFilter: formFilter,
      data: temp.filter(e => e.isChecked)
    }
    props.listenSelected(selected)
  }

  const checkedAll = (val) => {
    let temp = cloneDeep(data)
    temp.map(e => {
      e.isChecked = val
      return e
    })
    setData(temp)
    const selected = {
      formFilter: formFilter,
      data: temp.filter(e => e.isChecked)
    }
    props.listenSelected(selected)
  }

  const addColumn = () => {
    let temp = cloneDeep(config.columns)
    temp.push(
      {
        Header: <div className="checkbox-in-column">
          <CustomInput
            id={side +'-check-all'}
            type="checkbox"
            onChange={(e) => {
              // console.log(e.target.checked)
              checkedAll(e.target.checked)
            }}
          />
        </div>,
        accessor: "isChecked",
        sortable: false,
        type: 'check',
        minWidth: 50,
        classList: "w-sm-100",
        Cell: (props) => {
          return <div className="checkbox-in-column">
            <CustomInput
              id={side +'-'+ props.index}
              type="checkbox"
              checked={props.value}
              onChange={(e) => {
                // console.log(e.target.checked)
                checkedItem(props.original.ID, e.target.checked)
              }}
            />
          </div>
        }
      }
    )
    setColumns(temp)
  }

  // equal to componentDidMount
  useEffect(() => {
    // console.log('mounted')
  }, []);

  useEffect(() => {
    if (prevStateFormFilter === null && formFilter) {
      addColumn()
      getData()
    }
    const selected = {
      formFilter: formFilter,
    }
    props.listenSelected(selected)
    // console.log(selected)
    // eslint-disable-next-line
  }, [formFilter]);

  useEffect(() => {
    // console.log(data)
    addColumn();
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (prevStateSearch && search === '') getData()
    // eslint-disable-next-line
  }, [search]);

  useEffect(() => {
    if(addItems && addItems.length > 0) {
      // console.log('add', addItems)
      const d = addItems.concat(data)
      setData(d)
    }
    // eslint-disable-next-line
  }, [addItems]);

  useEffect(() => {
    if(removeItems && removeItems.length > 0) {
      const d = data.filter(e => removeItems.map(o => o = o.ID).indexOf(e.ID) < 0)
      setData(d)
    }
    // eslint-disable-next-line
  }, [removeItems]);

  const query = () => {
    let pageSize = "?PageSize=10000"
    let fieldsToFilter = formFilter || {};
    let filters = objToQueryString(fieldsToFilter, false, true);
    let s = search ? '&filterBy=&filter=' + search : ''
    let page = '&page=1'
    return pageSize + filters + s + page
  }

  const getData = () => {
    setProgressBar(true)
    var path = config.GET
    _axios
      .get(path + query())
      .then(r => {
        if (r.status >= 0) {
          r.data.Results.map(e => {
            e.isChecked = false
            return e
          })
          setData(r.data.Results)
          setRowCount(r.data.Results.length)
          const selected = {
            formFilter: formFilter,
            data: []
          }
          props.listenSelected(selected)
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        setProgressBar(false)
      })
  }

  const listenStatesFormFilter = (s) => {
    // console.log(s)
    setFormFilter(s)
  }

  const handleChangeSearch = (e) => {
    setSearch(e.target.value)
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') getData()
  }

  return config ? <Row>
    <Colxx md={12}>
      <h5 className="mb-4">{config.title}</h5>
    </Colxx>

    <Colxx md={12}>
      {config.fields &&
        <FormCustom
          id={"form-flt"}
          fields={config.fields}
          listenStates={listenStatesFormFilter}
        />
      }
    </Colxx>

    <Colxx md={7} className="mb-4">
      {config.search &&
        <div className="search-lg min-w-100">
          <input
            type="text"
            id="search"
            value={search}
            placeholder="Buscar"
            onChange={handleChangeSearch}
            onKeyPress={handleKeyPress}
          />
          <i
            className={search ? "simple-icon-close" : "simple-icon-magnifier"}
            onClick={() => { setSearch('') }}
          ></i>
        </div>
      }
    </Colxx>

    <Colxx md={5} className="mb-4">
      <Button
        className="btn-sm btn-block truncate"
        type="button"
        color={'primary'}
        onClick={() => { getData() }}
      >
        <i className="iconsminds-filter-2"></i> Aplicar Filtros
      </Button>
    </Colxx>

    <Colxx md={12}>
      <DataTable
        progressBar={progressBar}
        data={data}
        defaultPageSize={10000}
        currentPage={1}
        columns={columns}
        rowCount={rowCount}
        hidePagination={true}
        maxHeight={'400px'}
      />
    </Colxx> 
  </Row> : ''
}

class SideToSide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      leftItemsSelected: null,
      rightItemsSelected: null,
      leftAdd: null,
      leftRemove: null,
      rightAdd: null,
      rightRemove: null,
    }
  }

  moveTo(to) {
    let left = cloneDeep(this.state.leftItemsSelected)
    let right = cloneDeep(this.state.rightItemsSelected)
    // console.log(left, right)
    let msg = () => NotificationManager.error('En el origen debe de seleccionar a los alumnos a mover y en el destino el grado y sección', "Error", 5000, null, null, 'outline')
    if (to === 'left' && (!right.formFilter || !right.data || right.data.length === 0 || !left.formFilter || !left.formFilter.sectionId)) return msg()
    else if (to === 'right' && (!left.formFilter || !left.data || left.data.length === 0 || !right.formFilter || !right.formFilter.sectionId)) return msg()

    let body = []
    if (to === 'left') body = right
    else body = left

    body = {
      fromSectionId: body.formFilter.sectionId ? body.formFilter.sectionId.value : null,
      sectionId: to === 'left' ? left.formFilter.sectionId.value : right.formFilter.sectionId.value,
      studentIds: body.data.map(e => e = e.ID)
    }
    // console.log(body)
    const path = to === 'left' ? this.props.configLeft.POST : this.props.configRight.POST
    _axios
      .post(path, body)
      .then(r => {
        this.props.setLoader(false)
        if (r.status >= 0) {
          this.props.setLoader(false)
          let data = cloneDeep(to === 'left' ? this.state.rightItemsSelected.data : this.state.leftItemsSelected.data)
          data.map(e => {
            e.isChecked = false
            e.sectionTag = to === 'left' ? (left.formFilter.superSectionId.label + ' ' + left.formFilter.sectionId.label.split(' ')[0]) : (right.formFilter.superSectionId.label + ' ' + right.formFilter.sectionId.label.split(' ')[0])
            return e
          }
            )
          if (to === 'left') this.setState({leftAdd: data, leftRemove: null, rightAdd: null, rightRemove: data})
          else this.setState({leftAdd: null, leftRemove: data, rightAdd: data, rightRemove: null})
          // reset data
          let le = this.state.leftItemsSelected
          let ri = this.state.rightItemsSelected
          le.data = []
          ri.data = []
          this.setState({ leftItemsSelected: le, rightItemsSelected: ri })
          NotificationManager.success(r.msg, "", 5000, null, null, 'outline')
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      })
      .catch((e) => { this.props.setLoader(false) })
  }

  render() {
    const { configLeft, configRight } = this.props
    return (
      <Row>
        <Colxx md={5}>
          <Side
            side={'left'}
            config={configLeft}
            listenSelected={(selected) => { this.setState({leftItemsSelected: selected }) }}
            addItems={this.state.leftAdd}
            removeItems={this.state.leftRemove}
          />
        </Colxx>

        <Colxx md={2} style={{ marginBottom: '213px', display: 'flex', alignItems: 'end', flexWrap: 'wrap' }}>
          <div className="w-100">
          <Button
              className="default btn-block"
              type="button"
              color={'primary'}
              onClick={() => { this.moveTo('right') }}
            >
              <i className="simple-icon-arrow-right"></i>
            </Button>
            <Button
              className="default btn-block"
              type="button"
              color={'primary'}
              onClick={() => { this.moveTo('left') }}
            >
              <i className="simple-icon-arrow-left"></i>
            </Button>
          </div>
        </Colxx>

        <Colxx md={5}>
          <Side
            side={'right'}
            config={configRight}
            listenSelected={(selected) => { this.setState({rightItemsSelected: selected }) }}
            addItems={this.state.rightAdd}
            removeItems={this.state.rightRemove}
          />
        </Colxx>
      </Row>
    );
  }
};

const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale };
};

export default connect(mapStateToProps, { setLoader })(SideToSide);
